import { call, put, takeLatest, select } from "redux-saga/effects";

import types from "./types";
import api from "./api";
import actions, { add_single_address } from "./actions";
import selectors from "./selectors";

export function* login(action) {
  const { cellphone, onSuccess, onFailed } = action.payload;

  try {
    const { data } = yield api.login(cellphone);

    yield put(
      actions.set_phone({
        cellphone,
        meta: data,
      })
    );

    if (onSuccess) onSuccess(data);
  } catch (err) {
    console.log("error", err, err.response);

    if (onFailed) onFailed(err);

    return false;
  }
}

export function* login_verify(action) {
  const { code, onSuccess, onFailed } = action.payload;
  const state = yield select();

  try {
    const { data } = yield api.login_check(state.user.login.meta.token, code);

    yield put(
      actions.set_token({
        token: data.token,
      })
    );

    const profile_response = yield api.get_profile(data.token);

    yield put(actions.set_profile(profile_response));
    if (onSuccess) onSuccess(data);
  } catch (err) {
    console.log("error", err, err.response);

    if (onFailed) onFailed(err);

    return false;
  }
}

export function* get_address(action) {
  const {
    payload: { onSuccess, onFailed },
  } = action;
  // const token = yield select(selectors.getToken);

  try {
    const { data } = yield api.get_address();

    yield put(actions.set_user_address(data));

    if (onSuccess) onSuccess(data);
  } catch (err) {
    console.log("error", err, err.response);

    if (onFailed) onFailed(err);

    return false;
  }
}

export function* add_address(action) {
  const {
    payload: { onSuccess, onFailed, address, latitude, longitude, title },
  } = action;
  // const token = yield select(selectors.getToken);

  try {
    const { data } = yield api.add_address({
      address,
      latitude,
      longitude,
      title,
    });

    yield put(add_single_address(data));

    if (onSuccess) onSuccess(data);
  } catch (err) {
    console.log("error", err, err.response);

    if (onFailed) onFailed(err);

    return false;
  }
}

export function* get_orders(action) {
  const payload = action.payload || {};
  const { onSuccess, onFailed } = payload;
  // const token = yield select(selectors.getToken);

  try {
    const { data } = yield api.get_orders();

    yield put(actions.set_orders(data));

    // if( action && action.payload && onSuccess ) onSuccess(data);
  } catch (err) {
    console.log("error", err, err.response);

    if (onFailed) onFailed(err);

    return false;
  }
}

export default [
  takeLatest(types.LOGIN_REQUEST, login),
  takeLatest(types.LOGIN_VERIFY, login_verify),
  takeLatest(types.USER_ADRESS_REQUEST, get_address),
  takeLatest(types.ADD_ADRESS_REQUEST, add_address),
  takeLatest(types.GET_ORDERS, get_orders),
];
